import React, { useEffect, useState } from "react";
import { Navigate, useParams, useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import axios from "axios";
import LoadingOverlay from "../components/LoadingOverlay"; // 追加

interface Props {
  children: JSX.Element;
}

const RequireTfSheetAccess: React.FC<Props> = ({ children }) => {
  const { authUser, isFetchingUser } = useUser();
  const { userId } = useParams<{ userId: string }>();
  const location = useLocation();

  const [accessAllowed, setAccessAllowed] = useState<boolean | null>(null); // null=判定中

  useEffect(() => {
    if (isFetchingUser) return;

    const myUserId = authUser?.id?.toString() ?? "";
    const isAdmin = authUser?.isTfAdmin ?? false;
    const isSales = authUser?.isTfSales ?? false;

    // isAdmin または isSales は全OK
    if (isAdmin || isSales) {
      setAccessAllowed(true);
      return;
    }

    // 自分のuserIdならOK
    if (userId === myUserId) {
      setAccessAllowed(true);
      return;
    }

    type ApiResponse = { allowed: boolean };

    axios
      .get<ApiResponse>(
        `${process.env.REACT_APP_BACKEND_URL}/api/tf/my-sheet-access/${userId}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setAccessAllowed(res.data.allowed);
      })
      .catch(() => {
        setAccessAllowed(false);
      });
  }, [authUser, isFetchingUser, userId]);

  // 🔥 isFetchingUser中はLoadingOverlayを表示
  if (isFetchingUser || accessAllowed === null) {
    return <LoadingOverlay />;
  }

  if (!accessAllowed) {
    return <Navigate to="/404" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireTfSheetAccess;
